<template>
  <div class="userInfo">
    <a class="Logo">
      <img class="leave" :src="enterprise.logo" />
    </a>
    <p :style="{marginTop:'10px',}">{{enterprise.name}}</p>
    <el-menu class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-submenu index="2">
        <template slot="title" style="border:none;">切换企业</template>
        <el-menu-item
          style="width:244px;overflow: hidden;
                  text-overflow:ellipsis;
                  white-space: nowrap;"
          v-for="(item)  in enterprises"
          :key="item.enterprise_id"
          :index="item.enterprise_id"
          :title="item.name"
        >{{item.name}}</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: [],
  name: 'EnTitle',
  data() {
    return {};
  },
  computed: {
    enterprise() {
      return this.$store.state.enterprise.current;
    },
    enterprises() {
      return this.$store.state.enterprise.enterprises;
    },
    open_market() {
      return this.$store.state.enterprise.current.open_market;
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.enterprise_id = key;
      const list = this.$store.state.enterprise.enterprises;

      list.map(item => {
        const { enterprise_id } = item;
        if (enterprise_id === key) {
          this.$store.dispatch('SetCurrentEnterprise', enterprise_id);
          this.$router.push({
            name: 'overviewAll',
            params: {
              enterpriseID: key,
              orderState: 'all',
              orderManageType: 'merchants'
            },
            query: this.$route.query
          });
          return;
        }
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/layout/components/EnTitle.vue